import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import type { LanesParams } from '../../models';
import { CACHE_KEYS } from '../../types';
import { logger } from '../../utils/logger';
import { api } from './api';
import { normalizeLanes } from './normalize';

export const fetchLanes = createProvider(api.fetchLanes)
  .andThen((res) => normalizeLanes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Fetch lanes search results list aborted');
    } else {
      logger.error('Fetch lanes search results list was failed:', error);
    }
    throw error;
  });

export const lanesOptions = (params: LanesParams) =>
  queryOptions({
    enabled: Boolean(params.destinationCountry && params.originCountry),
    queryFn: ({ signal }) => fetchLanes(params, { signal }),
    queryKey: CACHE_KEYS.lanes(params),
  });
